export const SET_RENVOIE_RESULTS = 'paye-bo/renvoie/SET_RENVOIE_RESULTS'

const initialState = {
  renvoieResults: [],
}

export default function renvoieModule(state = initialState, { type, value }) {
  switch (type) {
    case SET_RENVOIE_RESULTS:
      return { ...state, renvoieResults: value }
    default:
      return state
  }
}
